<template>
	<div v-if="isBlockShown" class="col-12">
		<div class="panel_header">
			<div class="row align-items-end">
				<div v-if="block.block_title" class="col-12">
					<h2>{{ block.block_title }}</h2>
				</div>
				<div v-if="block.subtitle" class="col-12">
					<p>{{ block.subtitle }}</p>
				</div>
			</div>
		</div>

		<div v-if="okSuccessMessage">
			<div>
				<div>
					<h4 class="title title-lg mb-4">
						{{ okSuccessMessage.title }}
					</h4>
					<div v-html="okSuccessMessage.value" />
				</div>
				<div
					v-if="okSuccessMessage.is_button_enabled == 1"
					class="p-4 w-lg-50"
				>
					<a :href="okSuccessMessage.button_link">
						<b-button variant="primary">
							{{ okSuccessMessage.button_text }}
						</b-button>
					</a>
				</div>
			</div>

			<FormulateInput
				type="button"
				@click="onClickAgainSubmit"
			>
				{{ $t('sendAgain') }}
			</FormulateInput>
		</div>
		<div v-else>
			<div
				v-if="mounted && autocompleted
					&& (block.is_user_quantity_restriction_enabled === 0 || isUserEnabled) && !isFormClosed"
				class="row"
			>
				<div class="col-12 col-lg data-block">
					<FormulateForm
						v-if="((isAuthorized && block.authentication_required)
							|| !block.authentication_required)"
						v-model="formValues"
						:schema="schema"
						:name="block.type"
						class="row"
						@submit="submit"
						@setCompanyInfo="setCompanyInfo"
						@onChangeSwitchMiddleName="onChangeSwitchMiddleName"
						@validatePhone="validatePhone"
					>
						<div class="col-12 order-0 mb-4">
							<products-component v-model="products" :block="block" />
						</div>

						<div class="col-12 order-10 mb-4">
							<div v-html="block.footer_text" />

							<agreement-input />

							<agree-refuse-alumni-club-leaders-input
								v-if="block.agree_refuse_alumni_club_leaders"
								:required="true"
							/>

							<agree-regulations-clubs-input
								v-if="block.agree_regulations_clubs"
								:required="true"
							/>

							<PublicOfferAgreementInput
								v-for="(item, index) in block.agreements"
								:key="index"
								:href="item"
							/>

							<advertising-mailings-input />

							<loyalty-registration-input	/>

							<b2b-alumni-input v-if="block.showb2bAlumniInput" />
						</div>
						<LoyaltyFormBlock
							v-if="(isBlockContainsLoyaltyEarnProduct || isBlockContainsLoyaltyChargeProduct)"
							:products="block.products"
							:fetched-data="fetchedData"
							:selected-products="selectedProducts?.length ? selectedProducts : block.products"
							class="charge-points col-12 d-block d-lg-none mb-3 order-3"
							:is-formulate="true"
						/>
						<div class="col-12 order-10">
							<FormulateInput
								type="submit"
								class="mb-0 mt-2"
								:disabled="isLoadingSubmit"
							>
								<b-spinner
									v-if="isLoadingSubmit"
									style="
										margin-right: 15px;
										width: 1.3em;
										height: 1.3em;
									"
								/>
								{{ isLoadingSubmit ? $t("sending") : $t("send") }}
							</FormulateInput>
							<div v-if="errorMessage" class="text-success mt-2">
								{{ errorMessage }}
							</div>
							<CookieError v-if="isErrorCookie" />
						</div>
					</FormulateForm>
				</div>
				<LoyaltyFormBlock
					v-if="(isBlockContainsLoyaltyEarnProduct || isBlockContainsLoyaltyChargeProduct)"
					:products="block.products"
					:fetched-data="fetchedData"
					:selected-products="selectedProducts?.length ? selectedProducts : block.products"
					class="col-12 col-lg-5 pl-lg-5 d-none d-lg-block pr-lg-5"
					:is-formulate="true"
				/>
				<div v-if="!isAuthorized && block.authentication_required">
					<div class="col-12 mb-3">
						{{ $t("necessaryRegister") }}
					</div>
					<FormulateInput
						type="button"
						class="mb-0 col-12"
						:disabled="isLoadingSubmit"
						@click="showLoginPopup"
					>
						{{ $t("logIn") }}
					</FormulateInput>
				</div>
			</div>
			<div
				v-else-if="
					block.is_user_quantity_restriction_enabled === 1 &&
						!isUserEnabled
				"
				class="title"
			>
				{{ $t("alreadySubmitted") }}
			</div>
			<div v-else class="theme-inverse row justify-content-center py-5">
				<div class="title">
					{{ $t("registrationClosed") }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import ProductsComponent from '~/components/panels/formulate/products/ProductsComponent.vue';
import AgreementInput from '~/components/panels/formulate/products/components/AgreementInput.vue';
import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import LoyaltyRegistrationInput from '~/components/panels/formulate/products/components/LoyaltyRegistrationInput.vue';
import b2bAlumniInput from '~/components/panels/formulate/products/components/b2bAlumniInput.vue';
import PublicOfferAgreementInput from '~/components/panels/formulate/products/components/PublicOfferAgreementInput.vue';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';
import checkIsBlockShown from '~/mixins/checkIsBlockShown';
import LoyaltyFormBlock from '~/components/loyalty/LoyaltyFormBlock.vue';
import AgreeRegulationsClubsInput
	from '~/components/panels/formulate/products/components/AgreeRegulationsClubsInput.vue';
import AgreeRefuseAlumniClubLeadersInput
	from '~/components/panels/formulate/products/components/AgreeRefuseAlumniClubLeadersInput.vue';

export default {
	components: {
		AgreeRefuseAlumniClubLeadersInput,
		AgreeRegulationsClubsInput,
		LoyaltyFormBlock,
		b2bAlumniInput,
		LoyaltyRegistrationInput,
		AgreementInput,
		ProductsComponent,
		AdvertisingMailingsInput,
		CookieError,
		PublicOfferAgreementInput,
	},
	mixins: [formulateFormScenario, checkIsBlockShown],
	computed: {
		queryProducts() {
			return this.formValues.products ? this.block.products.filter((el) => this.formValues.products.includes(`${el.id}`)) : [];
		},
		isUserEnabled() {
			if (this.block.user) {
				return +this.block.user_restriction_quantity_per_user > this.block.user.pivot.count;
			}
			return true;
		},
	},
	watch: {
		queryProducts: {
			handler(array) {
				if (this.products.length == 0) {
					const products = this.formValues.products ? this.block.products.filter((el) => this.formValues.products.includes(`${el.id}`)) : [];
					this.selectedProducts = products;
				}
			},
			deep: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.text-decoration-none {
	cursor: pointer;
}
.formulate-form,
.custom-control-label,
.formulate-input,
.formulate-input .formulate-input-label {
	font-family: $font-family-base !important;
	font-weight: 500 !important;
}

.field-required {
	&.formulate-input[data-classification="text"] input {
		border: 1px solid red !important;
	}
}

.custom-switch {
	line-height: 1.8;
}
.alert-primary {
	color: $white;
	background-color: $link-color;
	border-color: $link-color;
}

.close_link {
	display: flex;
	align-items: center;
	justify-content: space-between;
	line-height: 1;
	padding: 0;
	border: 0;
	background: transparent;
	outline: 0;
	cursor: pointer;

	&::after {
		position: relative;
		content: "\e915";
		font-family: "sk_icons";
		line-height: 1;
		font-size: 0.8rem;
		margin-left: 0.5rem;
		padding: 4px;
		cursor: pointer;
	}
}

span {
	margin: 0;
	line-height: 1.3;

	&.price-muted {
		font-size: 1.5rem;
		text-decoration: line-through;
		color: $border-color;
	}
}

.end-price {
	background: #ffffff;
	.amount-wrapper {
		border-right: 1px dashed $border-color;
		height: 100%;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		padding-right: 30px;
	}
}

.amount {
	font-weight: bold;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	@include media-breakpoint-up(sm) {
		justify-content: space-between;
		flex-direction: row;
		align-items: center;
	}
}

.total-price {
	padding: 1rem;
	border: 1px solid $border-color;
	display: flex;
	background-color: #455fed;
	color: #ffffff;
	flex-direction: column;
	justify-content: space-between;
	@include media-breakpoint-up(sm) {
		padding: 2rem 1.5rem;
	}

	.description-small {
		font-weight: 400;
		line-height: 20px;
		color: #9ba9f7;
	}

	.education {
		border-top: 1px solid #ffffff;
	}

	input {
		background-color: transparent;
		border: none;
		border-bottom: 1px solid $border-color;
		width: 100%;
		outline-style: none;

		&::placeholder {
			color: $border-color;
		}
	}

	.input_under_span {
		font-size: 0.8rem;
		line-height: 1.2;
		font-weight: normal;
	}

	.btn-outline-secondary {
		color: $border-color;
		border-color: $border-color;

		&:hover {
			color: $white;
			border-color: $link-hover-color;
			background-color: $link-hover-color;
		}
	}

	.sum {
		margin: 2rem 0;
	}
}
// .custom-control-input:checked ~ .custom-control-label::before {
// 	color: #fff;
// 	border: #FFFFFF;
// }

.discount {
	.formulate-input-element {
		&.formulate-input-element--text {
			input {
				border: none !important;
				border-bottom: 1px solid black !important;
				padding-left: 0px !important;
				padding-bottom: 1rem !important;

				&::placeholder {
					color: black !important;
				}
			}
		}
		&.formulate-input-element--submit {
			button {
				font-weight: 400 !important;
			}
		}
	}
}
</style>
